/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { CapiCodeId } from './capiCodeId';
import { TeilDatumSearchRequestMeta } from './teilDatumSearchRequestMeta';
import { HistorySearchOptionsMeta } from './historySearchOptionsMeta';
import { ElasticSearchOptions } from './elasticSearchOptions';


export interface PersonGbSearchErweitertRequestMeta { 
    isSearchUebrigeBerechtigteEnabled?: boolean;
    mIsSearchUebrigeBerechtigteEnabled?: FieldMetaData;
    ledigname?: string;
    mLedigname?: FieldMetaData;
    ort?: string;
    mOrt?: FieldMetaData;
    vorname?: string;
    mVorname?: FieldMetaData;
    codeSchuldner?: CapiCodeId;
    mCodeSchuldner?: FieldMetaData;
    strasse?: string;
    mStrasse?: FieldMetaData;
    hausnummer?: string;
    mHausnummer?: FieldMetaData;
    mPersonStammVersionArtList?: Array<PersonGbSearchErweitertRequestMeta.MPersonStammVersionArtListEnum>;
    mMPersonStammVersionArtList?: FieldMetaData;
    name?: string;
    mName?: FieldMetaData;
    plz?: string;
    mPlz?: FieldMetaData;
    rolle?: PersonGbSearchErweitertRequestMeta.RolleEnum;
    mRolle?: FieldMetaData;
    sortDirection?: PersonGbSearchErweitertRequestMeta.SortDirectionEnum;
    mSortDirection?: FieldMetaData;
    ahvNummer?: string;
    mAhvNummer?: FieldMetaData;
    sitz?: string;
    mSitz?: FieldMetaData;
    rolleEigentuemer?: boolean;
    mRolleEigentuemer?: FieldMetaData;
    historySearchOptions?: HistorySearchOptionsMeta;
    mHistorySearchOptions?: FieldMetaData;
    codeGlaeubiger?: CapiCodeId;
    mCodeGlaeubiger?: FieldMetaData;
    personStammVersionArt?: PersonGbSearchErweitertRequestMeta.PersonStammVersionArtEnum;
    mPersonStammVersionArt?: FieldMetaData;
    glaeubigerrolle?: PersonGbSearchErweitertRequestMeta.GlaeubigerrolleEnum;
    mGlaeubigerrolle?: FieldMetaData;
    rolleUebrigeBerechtigeVormerkung?: boolean;
    mRolleUebrigeBerechtigeVormerkung?: FieldMetaData;
    geburtsdatum?: TeilDatumSearchRequestMeta;
    mGeburtsdatum?: FieldMetaData;
    rolleUebrigeBerechtigeDienstbarkeit?: boolean;
    mRolleUebrigeBerechtigeDienstbarkeit?: FieldMetaData;
    rolleSchuldner?: boolean;
    mRolleSchuldner?: FieldMetaData;
    ahvVersichertennummer?: string;
    mAhvVersichertennummer?: FieldMetaData;
    rolleUebrigeBerechtigeAnmerkung?: boolean;
    mRolleUebrigeBerechtigeAnmerkung?: FieldMetaData;
    mGlaeubigerrolleList?: Array<PersonGbSearchErweitertRequestMeta.MGlaeubigerrolleListEnum>;
    mMGlaeubigerrolleList?: FieldMetaData;
    elasticSearchOptions?: ElasticSearchOptions;
    mElasticSearchOptions?: FieldMetaData;
    isSearchEigentuemerEnabled?: boolean;
    mIsSearchEigentuemerEnabled?: FieldMetaData;
    rolleUebrigeBerechtigeGrundlast?: boolean;
    mRolleUebrigeBerechtigeGrundlast?: FieldMetaData;
    uid?: string;
    mUid?: FieldMetaData;
    isSearchGlaeubigerSchuldnerEnabled?: boolean;
    mIsSearchGlaeubigerSchuldnerEnabled?: FieldMetaData;
    rolleGlaeubiger?: boolean;
    mRolleGlaeubiger?: FieldMetaData;
    personStammSort?: PersonGbSearchErweitertRequestMeta.PersonStammSortEnum;
    mPersonStammSort?: FieldMetaData;
}
export namespace PersonGbSearchErweitertRequestMeta {
    export type MPersonStammVersionArtListEnum = 'NATUERLICHE_PERSON' | 'SCHWEIZERISCHE_JURISTISCHE_PERSON' | 'OEFFENTLICHE_KOERPERSCHAFT' | 'AUSLAENDISCHE_RECHTSFORM';
    export const MPersonStammVersionArtListEnum = {
        NATUERLICHE_PERSON: 'NATUERLICHE_PERSON' as MPersonStammVersionArtListEnum,
        SCHWEIZERISCHE_JURISTISCHE_PERSON: 'SCHWEIZERISCHE_JURISTISCHE_PERSON' as MPersonStammVersionArtListEnum,
        OEFFENTLICHE_KOERPERSCHAFT: 'OEFFENTLICHE_KOERPERSCHAFT' as MPersonStammVersionArtListEnum,
        AUSLAENDISCHE_RECHTSFORM: 'AUSLAENDISCHE_RECHTSFORM' as MPersonStammVersionArtListEnum
    };
    export type RolleEnum = 'EIGENTUEMER' | 'UEBRIGE_BERECHTIGTE' | 'GLAEUBIGER_SCHULDNER' | 'ALLE';
    export const RolleEnum = {
        EIGENTUEMER: 'EIGENTUEMER' as RolleEnum,
        UEBRIGE_BERECHTIGTE: 'UEBRIGE_BERECHTIGTE' as RolleEnum,
        GLAEUBIGER_SCHULDNER: 'GLAEUBIGER_SCHULDNER' as RolleEnum,
        ALLE: 'ALLE' as RolleEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
    export type PersonStammVersionArtEnum = 'NATUERLICHE_PERSON' | 'SCHWEIZERISCHE_JURISTISCHE_PERSON' | 'OEFFENTLICHE_KOERPERSCHAFT' | 'AUSLAENDISCHE_RECHTSFORM';
    export const PersonStammVersionArtEnum = {
        NATUERLICHE_PERSON: 'NATUERLICHE_PERSON' as PersonStammVersionArtEnum,
        SCHWEIZERISCHE_JURISTISCHE_PERSON: 'SCHWEIZERISCHE_JURISTISCHE_PERSON' as PersonStammVersionArtEnum,
        OEFFENTLICHE_KOERPERSCHAFT: 'OEFFENTLICHE_KOERPERSCHAFT' as PersonStammVersionArtEnum,
        AUSLAENDISCHE_RECHTSFORM: 'AUSLAENDISCHE_RECHTSFORM' as PersonStammVersionArtEnum
    };
    export type GlaeubigerrolleEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const GlaeubigerrolleEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        NUTZNIESSER: 'NUTZNIESSER' as GlaeubigerrolleEnum,
        ANDEREROLLE: 'ANDEREROLLE' as GlaeubigerrolleEnum
    };
    export type MGlaeubigerrolleListEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const MGlaeubigerrolleListEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as MGlaeubigerrolleListEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as MGlaeubigerrolleListEnum,
        NUTZNIESSER: 'NUTZNIESSER' as MGlaeubigerrolleListEnum,
        ANDEREROLLE: 'ANDEREROLLE' as MGlaeubigerrolleListEnum
    };
    export type PersonStammSortEnum = 'BEZEICHNUNG' | 'ART';
    export const PersonStammSortEnum = {
        BEZEICHNUNG: 'BEZEICHNUNG' as PersonStammSortEnum,
        ART: 'ART' as PersonStammSortEnum
    };
}


